import React from 'react';
import { motion } from 'framer-motion';
import HeroSection from './components/HeroSection';
import ProblemSection from './components/ProblemSection';
import WorkshopDays from './components/WorkshopDays';
import BonusSection from './components/BonusSection';
import ValueStack from './components/ValueStack';
import WhoThisIsFor from './components/WhoThisIsFor';
import FinalCTA from './components/FinalCTA';
import RegistrationModal from './components/RegistrationModal';
import './App.css';

function App() {
  const [isModalOpen, setIsModalOpen] = React.useState(false);

  const openModal = () => setIsModalOpen(true);
  const closeModal = () => setIsModalOpen(false);

  return (
    <div className="min-h-screen bg-gray-900">
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.8 }}
      >
        <HeroSection onRegisterClick={openModal} />
        <ProblemSection />
        <WorkshopDays />
        <BonusSection />
        <ValueStack />
        <WhoThisIsFor />
        <FinalCTA onRegisterClick={openModal} />
      </motion.div>
      
      <RegistrationModal isOpen={isModalOpen} onClose={closeModal} />
      
      {/* Sticky Mobile CTA */}
      <div className="fixed bottom-0 left-0 right-0 z-40 md:hidden">
        <button
          onClick={openModal}
          className="w-full bg-gradient-to-r from-red-600 to-red-500 text-white py-4 px-6 font-bold text-lg shadow-2xl"
        >
          🔴 Register FREE Now
        </button>
      </div>
    </div>
  );
}

export default App;